module.exports = __webpack_public_path__ + "static/media/backyard.8353e580.jpg";